"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RateLimiter_instances, _RateLimiter_deleteOld;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimiter = exports.RateLimiterError = void 0;
class RateLimiterError extends Error {
    constructor(info) {
        super(`Rate limit reach ${info.count}`);
        this.name = "RateLimiterError";
        this.info = info;
    }
}
exports.RateLimiterError = RateLimiterError;
class RateLimiter {
    constructor(window = 60000, maxCalls = 60) {
        _RateLimiter_instances.add(this);
        this.window = window;
        this.maxCalls = maxCalls;
        this.data = {};
    }
    getRateLimit(key) {
        var _a, _b;
        __classPrivateFieldGet(this, _RateLimiter_instances, "m", _RateLimiter_deleteOld).call(this);
        const currentTime = Date.now();
        const info = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : { count: 0, renewTime: currentTime + this.window };
        if (++info.count > this.maxCalls)
            throw new RateLimiterError(info);
        return this.data[key] = info;
    }
}
exports.RateLimiter = RateLimiter;
_RateLimiter_instances = new WeakSet(), _RateLimiter_deleteOld = function _RateLimiter_deleteOld() {
    const currentTime = new Date().getTime();
    var toDelete = Object.entries(this.data).filter(([key, info]) => info.renewTime < currentTime);
    toDelete.forEach(([key, info]) => delete this.data[key]);
};
//# sourceMappingURL=rate-limiter.js.map